import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from "@angular/core";
import { Stakeable } from "@modules/staking/domain/entities/stakeable.model";
import { Fiat } from "@models";
import { StakeableAvailability } from "@modules/staking/domain/entities/stakable-availability.model";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import { convertTradableToFiat } from "@helpers/tradable-convert";
import { TradableListService } from "@main-services/currency/tradable_list.service";

@Component({
	selector: "stakeable-list-item",
	templateUrl: "./stakeable-list-item.component.html",
	styleUrls: ["./stakeable-list-item.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class StakeableListItemComponent implements OnInit {
	@HostBinding("class") public cssClass: string = "";
	@Input() public stakeable: Stakeable = null;
	@Input() public fiat: Fiat = null;

	public isSoldOut: boolean = false;
	public defaultWalletBalance: number = 0;

	public constructor(
		private readonly tradableWalletService: TradableWalletListService,
		private readonly tradableListService: TradableListService
	) {}

	public ngOnInit(): void {
		this.isSoldOut = this.stakeable.availability === StakeableAvailability.SOLD_OUT;
		if (this.isSoldOut) {
			this.cssClass = "disabled";
		}
		const wallets = this.tradableWalletService.getWalletsByTradableId(this.stakeable.id) ?? [];
		const defaultWallet = wallets.find((w) => w.isDefault());
		if (!defaultWallet) {
			this.defaultWalletBalance = 0;
			return;
		}

		const tradable = this.tradableListService.getItemById(this.stakeable.id);
		if (!tradable) {
			this.defaultWalletBalance = 0;
			return;
		}

		const tradableAmount: number = defaultWallet.getBalance();
		this.defaultWalletBalance = convertTradableToFiat(tradable, tradableAmount, this.fiat);
	}
}
